import React from 'react';
import EnergiaTartaly from './components/EnergiaTartaly';
import './App.css';

function App() {
  return (
    <div className="App">
      <EnergiaTartaly />
    </div>
  );
}

export default App;